module.exports = __webpack_public_path__ + "static/media/sunDown.284d0e23.jpg";